/* Open Road -- products-per-page dropdown on the shop and category pages.
 *
 * The page size is the ?view= parameter: the default template uses its own
 * setting, and collection.48 / collection.96 are alternates for the larger
 * sizes (Liquid cannot read an arbitrary query parameter, so the template
 * suffix is the only way to carry it). Changing size therefore navigates:
 * every other parameter -- filters, sort -- is kept, and only the page number
 * is dropped, since page 5 of 24 is not page 5 of 96.
 *
 * The select sits inside FacetSortForm for layout, and facets.js re-filters on
 * ANY input event inside that form. Stopping the event at the select keeps it
 * from firing a pointless section re-render just before we navigate away.
 *
 * Delegated from document, because facets.js replaces #ProductGridContainer
 * (where the phone-sized copy lives) every time a filter changes.
 *
 * window.OrPerPage.urlFor is pure, and .navigate is the only side effect, so a
 * test can swap navigate out -- location.assign itself cannot be stubbed.
 *
 * Wide Angle preview (body.wa): there are no 48 / 96 preview alternates, so the
 * URL keeps view=<preview suffix> and the size goes in wa-per, which
 * wa-collection.js reads to load the extra pages in place. Customer pages pass
 * no preview value and behave exactly as before.
 */
(function () {
  if (window.OrPerPage) return;

  var OrPerPage = {
    urlFor: function (href, value, defaultSize, preview) {
      var url = new URL(href);
      url.searchParams.delete('page');
      url.searchParams.delete('view');
      if (preview) {
        url.searchParams.delete('wa-per');
        url.searchParams.set('view', preview);
        if (String(value) !== String(defaultSize)) url.searchParams.set('wa-per', value);
      } else if (String(value) !== String(defaultSize)) url.searchParams.set('view', value);
      var q = url.searchParams.toString();
      return url.pathname + (q ? '?' + q : '');
    },
    navigate: function (path) { window.location.assign(path); }
  };
  window.OrPerPage = OrPerPage;

  document.addEventListener('input', function (event) {
    if (event.target.closest && event.target.closest('[data-or-perpage]')) event.stopPropagation();
  }, true);

  document.addEventListener('change', function (event) {
    var select = event.target.closest && event.target.closest('[data-or-perpage]');
    if (!select) return;
    event.stopPropagation();
    var preview = '';
    if (document.body.classList.contains('wa')) {
      var field = document.querySelector('#FacetSortForm input[name="view"]') || document.querySelector('form[id^="Facet"] input[name="view"]');
      if (field && /^wa-preview/.test(field.value)) preview = field.value;
    }
    OrPerPage.navigate(OrPerPage.urlFor(window.location.href, select.value, select.dataset.default, preview));
  }, true);
})();
